import React from "react";
import Hero from "../components/home/Hero";
import SectionHeading from "../components/shared/SectionHeading";
import TrustedBrandsCopy from "../components/home/TrustedBrandsAndCopy";
import UniversityPartners from "../components/home/UniversityPartner";
import Mentors from "../components/home/Mentor";
import Testimonials from "../components/home/Testimonials";
import JoinMentorsity from "../components/home/JoinMentorsity";
import AlumniWorkplace from "../components/home/AlumniWorkplace";
import ExploreCourses from "../components/explorePrograms/ExploreCourses";
import WhyChoose from "../components/home/WhyChoose";
import OneStop from "../components/home/OneStop";

const Home = () => {
  return (
    <div className="flex flex-col h-auto">
      <div className="w-[90%] sm:w-11/12 md:w-4/5 lg:w-3/4 xl:w-[85%] mx-auto text-center">
        <Hero />
        {/* //Trusted Brands */}
        <section className="mt-20 max-w-[1200px] mx-auto">
          <SectionHeading>
            <span className="text-3xl text-primary-color">Trusted</span>{" "}
            <span className="text-3xl text-secondary-color">Brands</span>
          </SectionHeading>
          <p className="mt-3 text-center text-base text-secondary2 font-normal">
            Trusted, Backed, And Powered By
          </p>
          <TrustedBrandsCopy />
        </section>

        {/* Explore Our Courses */}
        <section className="mt-14">
          <SectionHeading>
            <span className="text-primary-color">Explore Our</span>{" "}
            <span className="text-secondary-color">Courses</span>
          </SectionHeading>
          <ExploreCourses />
        </section>

        {/* Right Guidance */}
        <section className="mt-14 mx-auto">
          <div className="flex flex-col items-center">
            <SectionHeading>
              <span className="text-secondary-color">Right Guidance</span>{" "}
              <span className="text-primary-color">From the Right People</span>
            </SectionHeading>
            <p className="mt-3 font-normal text-secondary2 mx-auto text-center w-full max-w-[938px] text-sm md:text-base mb-4">
              Legends are not made by fate but by hard work and unmatched
              mentorship. Chanakya and his disciple Chandragupta are the perfect
              examples of it. Mentorsity is about providing each learner his/her
              Chanakya.
            </p>
            <div className="w-full">
              <Mentors />
            </div>
          </div>
        </section> 

        {/* Why Choose Mentorsity */}
        <section className="mt-16">
          <SectionHeading>
            <span className="text-primary-color">Why Choose </span>
            <span className="text-secondary-color">Mentorsity ?</span>
          </SectionHeading>
          <WhyChoose />
        </section>

        {/* One stop */}
        <section className="mt-20">
          <SectionHeading>
            <span className="text-secondary-color">One-stop solution </span>
            <span className="text-primary-color">for your Education</span>
          </SectionHeading>
          <OneStop />
        </section>

        {/* Where Our Alumni Work */}
        <section className="mt-16">
          <div className="mb-7">
            <SectionHeading>
              <span className="text-primary-color">Where Our</span>{" "}
              <span className="text-secondary-color">Alumni</span>{" "}
              <span className="text-primary-color">Work</span>
            </SectionHeading>
          </div>
          <AlumniWorkplace />
        </section>

        {/* University Partners */}
        <section className="mt-20">
          <SectionHeading>
            <span className="text-primary-color">
              University <span className="text-secondary-color">Partners</span>
            </span>
          </SectionHeading>
          <UniversityPartners />
        </section>


        {/* Testimonials */}
        <section className="mt-20">
          <SectionHeading>
            <span className="text-primary-color">Testimonials</span>
          </SectionHeading>
          <Testimonials />
        </section>

        {/* Join Mentorsity */}
        <section className="mt-9">
          <JoinMentorsity />
        </section>
      </div>
    </div>
  );
};

export default Home;
